import { render, staticRenderFns } from "./ReleaseTable.vue?vue&type=template&id=746fe247&scoped=true"
import script from "./ReleaseTable.vue?vue&type=script&lang=js"
export * from "./ReleaseTable.vue?vue&type=script&lang=js"
import style0 from "./ReleaseTable.vue?vue&type=style&index=0&id=746fe247&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "746fe247",
  null
  
)

export default component.exports